/**
 * Subscription Manager
 * Manages subscription expiration state and provides event-based communication
 * between axios interceptor and React components
 */

class SubscriptionManager {
  constructor() {
    this.listeners = new Set();
    this.isExpired = false;
  }

  /**
   * Subscribe to subscription expiration events
   * @param {Function} callback - Function to call when subscription expires
   * @returns {Function} Unsubscribe function
   */
  subscribe(callback) {
    this.listeners.add(callback);

    return () => {
      this.listeners.delete(callback);
    };
  }

  /**
   * Notify all listeners that subscription has expired
   * Prevents duplicate notifications if already expired
   */
  notifyExpired() {
    if (this.isExpired) {
      return;
    }

    this.isExpired = true;
    this.listeners.forEach((callback) => {
      try {
        if (typeof callback === "function") {
          callback(true);
        }
      } catch (error) {
        console.error("Error in subscription listener:", error);
      }
    });
  }

  /**
   * Reset subscription status (e.g., after successful subscription)
   */
  reset() {
    this.isExpired = false;
    this.listeners.forEach((callback) => {
      try {
        if (typeof callback === "function") {
          callback(false);
        }
      } catch (error) {
        console.error("Error in reset listener:", error);
      }
    });
  }

  /**
   * Get current expiration status
   */
  getStatus() {
    return this.isExpired;
  }
}

// Export singleton instance
export const subscriptionManager = new SubscriptionManager();
